import mixpanel from 'mixpanel-browser';

// Initialize mixpanel with your project token
// You'll need to replace 'YOUR_MIXPANEL_TOKEN' with your actual token
const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN || 'YOUR_MIXPANEL_TOKEN';

// Initialize mixpanel
mixpanel.init(MIXPANEL_TOKEN, {
  // Optional configuration
  debug: process.env.NODE_ENV !== 'production',
  track_pageview: true,
  persistence: 'localStorage',
});

// Export a safe tracking function
export const trackEvent = (eventName: string, properties?: any) => {
  if (typeof mixpanel !== 'undefined' && mixpanel.track) {
    mixpanel.track(eventName, properties);
  }
};

export default mixpanel;